export default __webpack_public_path__ + "static/media/arrow-left.41c4ec9c.svg";